const blockSocialSlide = (Swiper, Navigation, Pagination, Autoplay) => {
	const wrapSocial = document.querySelectorAll('.js-social-slider');

	if (wrapSocial) {
		wrapSocial.forEach((wrapper) => {
			let swiperSocial = wrapper.querySelector('.s-social-media__swiper');
			const arrowPrev = wrapper.querySelector('.c-swiper-single-arrow.c-swiper-single-arrow--prev');
			const arrowNext = wrapper.querySelector('.c-swiper-single-arrow.c-swiper-single-arrow--next');

			if (swiperSocial) {
				swiperSocial = new Swiper(swiperSocial, {
					slidesPerView: 1,
					spaceBetween: 75,
					modules: [Navigation, Pagination, Autoplay],
					navigation: {
						nextEl: arrowNext,
						prevEl: arrowPrev,
					},
					breakpoints: {
						768: {
							slidesPerView: 2,
						},
						992: {
							slidesPerView: 3,
						},
						1200: {
							slidesPerView: 3,
						},
						1400: {
							slidesPerView: 4,
						},
					},
				});
			}
		});
	}
};

export default blockSocialSlide;
